export type RestaurantAdminSubPage = 'menu' | 'settings' | 'active' | 'report';

export type ParsedRestaurantAdminSubRoute = {
  restaurantId: string;
  sub: RestaurantAdminSubPage;
};

const SUB_PATH_RE =
  /^\/restaurants\/([^/?#]+)\/(menu|settings|active|report)\/?$/;

export function parseRestaurantAdminSubRoute(pathname: string): ParsedRestaurantAdminSubRoute | null {
  const path = pathname.replace(/\/$/, '') || '/';
  const m = path.match(SUB_PATH_RE);
  if (!m) return null;
  const restaurantId = decodeURIComponent(m[1]).trim();
  const sub = m[2] as RestaurantAdminSubPage;
  if (!restaurantId) return null;
  return { restaurantId, sub };
}

export function restaurantAdminSubPath(restaurantId: string, sub: RestaurantAdminSubPage): string {
  return `/restaurants/${encodeURIComponent(String(restaurantId).trim())}/${sub}`;
}

const SUB_PAGE_SNAPSHOT_KEY = 'tzo.admin.restaurant.subPageSnapshot';

export function stashRestaurantSubPageSnapshot(restaurant: { id: string; [key: string]: unknown }): void {
  try {
    sessionStorage.setItem(
      SUB_PAGE_SNAPSHOT_KEY,
      JSON.stringify({ ...restaurant, id: String(restaurant.id) }),
    );
  } catch {
    /* ignore */
  }
}

export function readRestaurantSubPageSnapshot(restaurantId: string): Record<string, unknown> | null {
  try {
    const raw = sessionStorage.getItem(SUB_PAGE_SNAPSHOT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { id?: string };
    if (String(parsed.id) !== String(restaurantId)) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function pageTypeForRestaurantAdminSub(sub: RestaurantAdminSubPage):
  | 'menu-manage'
  | 'restaurant-settings'
  | 'restaurant-active'
  | 'restaurant-report' {
  switch (sub) {
    case 'menu':
      return 'menu-manage';
    case 'settings':
      return 'restaurant-settings';
    case 'active':
      return 'restaurant-active';
    case 'report':
      return 'restaurant-report';
  }
}
